import { call, put, takeEvery, select, take } from "redux-saga/effects"

// Types
import BusinessTypes from "Containers/BusinessInformations/types"

// Actions
import {
  getBusinessInformationsSuccessAction,
  getBusinessUsersSuccessAction,
  getMyBusinessInformationsAction,
  getBusinessUsersAction,
  getBusinessLogoAction,
  getBusinessLogoSuccess,
  uploadBusinessLogoSuccess,
  getAlreadyUsedEmailSuccess,
  getBusinessGroupAction,
  getBusinessGroupSuccessAction,
  getBusinessGroupByIdSuccessAction,
  addUserBusinessGroupAction,
  getMyGroupsSucessAction,
  getRolesAction,
  getRolesSuccess,
  getRolesOfUserSuccess,
  deleteRoleAction,
  deleteRoleSuccess,
} from "Containers/BusinessInformations/actions"

import { setErrorMessage } from "Containers/Messages/actions"

import { selectCurrentToken } from "Containers/Login/selectors"

import {
  selectBusiness,
  selectBusinessId,
  selectEmailChecked,
  selectBusinessIsLogoUploaded,
} from "Containers/BusinessInformations/selectors"

import { getOrganigrammeAction } from "Containers/Administration/actions"

import {
  responseTypeIsError,
  responseTypeIsSuccess,
  responseTypeIsWarning,
  handleResp,
  manageErrorGenerator,
  manageSuccessGenerator,
  manageWarningGenerator,
} from "Containers/App/saga"

// Utils
import { config } from "Utils/config"
import request from "Utils/request"
import { postCors, getCors, patchCors, postFileCors, deleteCors } from "Utils/rulesCors"
import { compressImageForStorage, safeSetLocalStorageItem } from "Utils/global"

//fonction helper
const arrayBufferToBase64 = buffer => {
  var binary = ""
  var bytes = new Uint8Array(buffer)
  var len = bytes.byteLength
  for (var i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i])
  }
  return window.btoa(binary)
}

// ***************************** //
//             Business          //
// ***************************** //

// Get les informations de l'entreprise
function* getMyBusinessInformationsSaga() {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { API_URL } = config
  const requestURL = `${API_URL}/myBusiness`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      }

      const responseBody = JSON.parse(JSON.stringify(response.body))
      const { business, rolesOfBusiness, rolesOfUser } = responseBody || {}
      const legacyResponse = { docs: business }
      yield put(getBusinessInformationsSuccessAction(legacyResponse))
      if (business?.useSeparatedRoles) {
        if (Array.isArray(rolesOfBusiness)) yield put(getRolesSuccess(rolesOfBusiness))
        if (Array.isArray(rolesOfUser)) yield put(getRolesOfUserSuccess(rolesOfUser))
      }
    }
  } catch (err) {
    var routeCalled = "[route] => /business/:businessId => ERROR => "
    console.error(routeCalled, err)
    yield put(setErrorMessage(err))
  }
}

function* updateBusinessInformations({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { API_URL } = config
  const requestURL = `${API_URL}/business`
  try {
    const response = yield call(request, requestURL, patchCors(payload, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      yield put(getMyBusinessInformationsAction())
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
    }
  } catch (err) {
    console.log("[route] --> /business | PATCH | ERROR |", err)
    yield put(setErrorMessage(err))
  }
}

function* getBusinessLogo({ payload }) {
  const token = yield select(selectCurrentToken)
  const isLogoUploaded = yield select(selectBusinessIsLogoUploaded)
  const specificHeaders = { token: token }

  console.log("payload =>", payload)

  const { API_URL } = config
  const requestURL = `${API_URL}/images`

  try {
    const response = yield call(request, requestURL, postCors(payload, specificHeaders))
    if (responseTypeIsError(response)) {
      // console.log("FAIL GET LOGO ===== ", response)
      window.localStorage.removeItem("businessLogo")
    } else {
      if (response.body.data) {
        if (responseTypeIsSuccess(response))
          yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        var imgData = arrayBufferToBase64(response.body.data)
        const fullDataUrl = `data:image/png;base64,${imgData}`
        // Compresser l'image avant de stocker
        try {
          const compressed = yield call(compressImageForStorage, fullDataUrl, 800, 800, 0.7)
          yield call(safeSetLocalStorageItem, "businessLogo", compressed, true)
        } catch (error) {
          console.warn("Erreur lors de la compression, utilisation de l'image originale:", error)
          yield call(safeSetLocalStorageItem, "businessLogo", fullDataUrl, true)
        }
        var actualDate = parseInt(Date.now() / 1000)
        yield put(getBusinessLogoSuccess(actualDate))
      }
    }
  } catch (err) {
    console.error("[route] --> /images | POST | ERROR |", err)
    yield put(setErrorMessage(err))
  }
}

function* uploadBusinessLogo({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }

  const { API_URL } = config
  const requestURL = API_URL + "/images/upload"

  const formData = new FormData()
  formData.append("file", payload.logo)
  formData.append("uploadType", "business")

  try {
    const response = yield call(request, requestURL, postFileCors(formData, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      var imgData = arrayBufferToBase64(response.body.data)
      const fullDataUrl = `data:image/png;base64,${imgData}`
      // Compresser l'image avant de stocker
      try {
        const compressed = yield call(compressImageForStorage, fullDataUrl, 800, 800, 0.7)
        yield call(safeSetLocalStorageItem, "businessLogo", compressed, true)
      } catch (error) {
        console.warn("Erreur lors de la compression, utilisation de l'image originale:", error)
        yield call(safeSetLocalStorageItem, "businessLogo", fullDataUrl, true)
      }
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
      var actualDate = parseInt(Date.now() / 1000)
      yield put(uploadBusinessLogoSuccess(actualDate))
    }
  } catch (err) {
    console.error("[route] --> /images/upload | POST | ERROR |", err)
    yield put(setErrorMessage(err))
  }
}

// ***************************** //
//             Roles             //
// ***************************** //

//SEPARATED ROLES
function* getRolesSaga() {
  const token = yield select(selectCurrentToken)
  const business = yield select(selectBusiness)

  const specificHeaders = { token: token }

  const { API_URL } = config
  const requestURL = API_URL + "/v2/rolesOfBusiness"

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    const params = { response, displayMessageToUser: { showError: true, showSuccess: false } }
    yield call(handleResp, params)
    if (responseTypeIsError(response)) return
    yield put(getRolesSuccess(response.body))
  } catch (err) {
    console.error("[route] --> /v2/rolesOfBusiness | GET | ERROR |", err)
    yield put(setErrorMessage(err))
  }
}

//SEPARATED ROLES
function* createRoleSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const business = yield select(selectBusiness)

  const specificHeaders = { token: token }

  const { API_URL } = config
  const requestURL = API_URL + "/v2/roles"

  try {
    const response = yield call(request, requestURL, postCors(payload, specificHeaders))
    const params = { response, displayMessageToUser: { showError: true, showSuccess: true } }
    yield call(handleResp, params)
    if (responseTypeIsError(response)) return
    yield put(getRolesAction())
  } catch (err) {
    console.error("[route] --> /v2/roles | POST | ERROR |", err)
    yield put(setErrorMessage(err))
  }
}

//SEPARATED ROLES
function* updateRoleSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const business = yield select(selectBusiness)

  const specificHeaders = { token: token }

  const { updatedRole, roleId } = payload || {}
  const { API_URL } = config
  const requestURL = `${API_URL}/v2/roles/${roleId}`

  const { module, ...updatedRoleWithoutModule } = updatedRole || {}
  try {
    const patchContent = patchCors(updatedRoleWithoutModule, specificHeaders)
    const response = yield call(request, requestURL, patchContent)
    const params = { response, displayMessageToUser: { showError: true, showSuccess: true } }
    yield call(handleResp, params)
    if (responseTypeIsError(response)) return
    yield put(getRolesAction())
  } catch (err) {
    console.error("[route] --> /v2/roles/:roleId | PATCH | ERROR |", err)
    yield put(setErrorMessage(err))
  }
}

//SEPARATED ROLES
function* deleteRoleSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }

  const { roleId } = payload
  const { API_URL } = config
  const requestURL = `${API_URL}/v2/roles/${roleId}`

  try {
    const response = yield call(request, requestURL, deleteCors(specificHeaders))
    const params = { response, displayMessageToUser: { showError: true, showSuccess: true } }
    yield call(handleResp, params)
    if (responseTypeIsError(response)) return
    yield put(getRolesAction())
  } catch (err) {
    console.error("[route] --> /v2/roles/:roleId | DELETE | ERROR |", err)
    yield put(setErrorMessage(err))
  }
}

function* createBusinessRole_OldVersion({ payload }) {
  const token = yield select(selectCurrentToken)
  const business = yield select(selectBusiness)

  const specificHeaders = { token: token }

  const { API_URL } = config
  const requestURL = API_URL + "/businessRoles"
  try {
    const response = yield call(
      request,
      requestURL,
      postCors(payload.business_role, specificHeaders)
    )
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else if (responseTypeIsWarning(response)) {
      yield call(manageWarningGenerator, { response, showMessageToUser: true })
    } else if (responseTypeIsSuccess(response)) {
      yield call(manageSuccessGenerator, { response, showMessageToUser: true })
      yield put(getMyBusinessInformationsAction())
    }
  } catch (err) {
    console.error("[route] --> /businessRoles | POST | ERROR |", err)
    yield put(setErrorMessage(err))
  }
}

function* updateBusinessRole({ payload }) {
  const token = yield select(selectCurrentToken)
  const business = yield select(selectBusiness)

  const specificHeaders = { token: token }

  const { API_URL } = config
  const requestURL = API_URL + "/businessRoles/" + payload.business_role.accessId

  try {
    const response = yield call(
      request,
      requestURL,
      patchCors(payload.business_role, specificHeaders)
    )
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
      yield put(getMyBusinessInformationsAction())
    }
  } catch (err) {
    console.error("[route] --> /businessRoles/:id | PATCH | ERROR |", err)
    yield put(setErrorMessage(err))
  }
}

function* deleteBusinessRole({ payload }) {
  const token = yield select(selectCurrentToken)
  const business = yield select(selectBusiness)

  const specificHeaders = { token: token }

  const { API_URL } = config
  const requestURL = API_URL + "/businessRoles/" + payload.business_role_id
  try {
    const response = yield call(request, requestURL, deleteCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else if (responseTypeIsSuccess(response)) {
      yield call(manageSuccessGenerator, { response, showMessageToUser: true })
      yield put(getMyBusinessInformationsAction())
    }
  } catch (err) {
    console.error("[route] --> /businessRoles/:id | DELETE | ERROR |", err)
    yield put(setErrorMessage(err))
  }
}

// ***************************** //
//             Users             //
// ***************************** //
// Get users via gestion entreprise
export function* getBusinessUsers() {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { API_URL } = config
  const requestURL = `${API_URL}/businessUsers`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(getBusinessUsersSuccessAction(response))
      return response.body
    }
  } catch (err) {
    console.error("[route] => /businessUsers/:id => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

// Get check if email is already used
function* getCheckEmailAlreadyUsed() {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const emailToCheck = yield select(selectEmailChecked)
  const { API_URL } = config
  const requestURL = `${API_URL}/user/checkEmailAlreadyUsed`

  try {
    const response = yield call(
      request,
      requestURL,
      postCors({ emailToCheck: emailToCheck }, specificHeaders)
    )
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      yield put(getAlreadyUsedEmailSuccess(response))
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
    }
  } catch (err) {
    console.error("[route] => /user/checkEmailAlreadyUsed => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* createUserSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const business = yield select(selectBusiness)
  const useSeparatedRoles = Boolean(business?.useSeparatedRoles)
  const businessId = business._id.$oid
  const specificHeaders = { token: token }

  const { API_URL } = config
  const requestURL = `${API_URL}/v2/user`

  try {
    const response = yield call(request, requestURL, postCors(payload, specificHeaders))
    const params = { response, displayMessageToUser: { showError: true, showSuccess: false } }
    yield call(handleResp, params)
    if (responseTypeIsError(response)) return
    yield put(getBusinessUsersAction({ businessId: businessId }))
    if (useSeparatedRoles) yield put(getRolesAction())
  } catch (err) {
    console.error("[route] => /v2/user => ERROR => ", err)
    yield put(setErrorMessage(response))
  }
}

function* updateUserSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const business = yield select(selectBusiness)
  const useSeparatedRoles = Boolean(business?.useSeparatedRoles)
  const specificHeaders = { token: token }
  const { API_URL } = config
  const requestURL = `${API_URL}/businessUsers/${payload.userId}`

  try {
    const response = yield call(request, requestURL, patchCors(payload, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      yield put(getBusinessUsersAction({ businessId: payload.id }))
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
      }
      if (useSeparatedRoles) yield put(getRolesAction())
    }
  } catch (err) {
    console.error("[route] => /businessUsers => ERROR => ", err)
    yield put(setErrorMessage(response))
  }
}

function* deleteUserSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { API_URL } = config
  const { userId, id } = payload
  const requestURL = `${API_URL}/businessUsers/${userId}`

  try {
    const response = yield call(request, requestURL, deleteCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      yield put(getBusinessUsersAction({ businessId: id }))
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
    }
  } catch (err) {
    console.error("[route] => /businessUsers => ERROR => ", err)
    yield put(setErrorMessage(response))
  }
}

// Update businessDefaultPaletteId
function* updateDefaultPalette({ payload }) {
  const token = yield select(selectCurrentToken)
  const businessID = yield select(selectBusinessId)
  const specificHeaders = { token: token }

  const { defaultPaletteId } = payload
  const { API_URL } = config
  const requestURL = `${API_URL}/businessPalettes`
  try {
    const response = yield call(
      request,
      requestURL,
      patchCors({ defaultPalette: defaultPaletteId }, specificHeaders)
    )
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      yield put(getMyBusinessInformationsAction())
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
    }
  } catch (err) {
    console.error("[route] => /businessPalettes => ERROR => ", err)
    yield put(setErrorMessage(response))
  }
}
// ***************************** //
//             GROUPS            //
// ***************************** //
// Get Groups
export function* getBusinessGroups() {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { API_URL } = config
  const requestURL = `${API_URL}/groups`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: false })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(getBusinessGroupSuccessAction(response))
      return response?.body
    }
  } catch (err) {
    console.error("[route] => /groups => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
// Get Groups by Id
function* getBusinessGroupById({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { API_URL } = config
  const { groupId } = payload
  const requestURL = `${API_URL}/group/${groupId}`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: false })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(getBusinessGroupByIdSuccessAction(response))
    }
  } catch (err) {
    console.error("[route] => /group/:groupId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
// Post Groups
function* createGroupSaga({ payload }) {
  const newLogo = payload?.moreInformations?.logo
  const isNewLogo = newLogo instanceof File
  const groupToPost = JSON.parse(JSON.stringify(payload))
  delete groupToPost?.moreInformations?.logo
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { API_URL } = config
  const requestURL = `${API_URL}/groups`

  try {
    const response = yield call(request, requestURL, postCors(groupToPost, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      const groupId = response.body?.newId
      if (isNewLogo) yield call(uploadClientLogo, { payload: { newLogo, groupId } })
      yield call(manageSuccessGenerator, { response, showMessageToUser: true })
      yield put(getBusinessGroupAction())
    }
  } catch (err) {
    console.error("[route] => /groups => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* updateGroupById({ payload }) {
  const { groupId, groupPatch } = payload
  const logo = groupPatch?.moreInformations?.logo
  const isNewLogo = logo instanceof File
  const newGroupToPatch = JSON.parse(JSON.stringify(groupPatch))
  delete newGroupToPatch?.moreInformations?.logo
  const token = yield select(selectCurrentToken)
  const business = yield select(selectBusiness)
  const specificHeaders = { token: token }
  const { API_URL } = config
  const requestURL = `${API_URL}/group/${groupId}`

  try {
    if (isNewLogo) {
      var postNewLogoResponse = yield call(uploadClientLogo, {
        payload: { newLogo: logo, groupId },
      })
      if (responseTypeIsError(postNewLogoResponse))
        yield call(manageErrorGenerator, { postNewLogoResponse, showMessageToUser: false })
    }

    const groupCanBePatched =
      !isNewLogo || (isNewLogo && responseTypeIsSuccess(postNewLogoResponse))

    if (groupCanBePatched) {
      const response = yield call(request, requestURL, patchCors(newGroupToPatch, specificHeaders))
      if (responseTypeIsError(response))
        yield call(manageErrorGenerator, { response, showMessageToUser: true })
      else {
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
        yield put(getBusinessGroupAction())
        yield put(getBusinessUsersAction({ businessId: business._id.$oid }))
        yield put(getOrganigrammeAction())
      }
    }
  } catch (err) {
    console.error("[route] => /group/:groupId/ => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

// If i'm client i can get MY business groups, not all
function* getMyBusinessGroups() {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { API_URL } = config
  const requestURL = `${API_URL}/myGroups`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: false })
    else yield call(manageSuccessGenerator, { response, showMessageToUser: false })
    yield put(getMyGroupsSucessAction(response))
  } catch (err) {
    console.error("[route] => /myGroups => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* deleteOrArchiveGroupByIdSaga({ payload }) {
  const { groupId, action = "archive" } = payload
  const token = yield select(selectCurrentToken)
  const business = yield select(selectBusiness)
  const businessTag = business?.tag
  const specificHeaders = { token: token }
  const { API_URL } = config
  const requestURL = `${API_URL}/group/${groupId}?action=${action}`

  try {
    const response = yield call(request, requestURL, deleteCors(specificHeaders))

    const params = {
      response,
      displayMessageToUser: { showError: true, showSuccess: true },
      businessTag: businessTag,
    }
    yield call(handleResp, params)
    if (responseTypeIsError(response)) return
    yield put(getBusinessGroupAction())
    // if (businessTag === "maryanne") yield put(getOrganigrammeAction())
  } catch (err) {
    console.error("[route] => /group/:groupId/ => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* uploadClientLogo({ payload }) {
  const { newLogo, groupId } = payload
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { API_URL } = config
  const requestURL = API_URL + "/images/upload"

  const formData = new FormData()
  formData.append("file", newLogo)
  formData.append("uploadType", "groupLogo")
  formData.append("groupId", groupId)

  try {
    const response = yield call(request, requestURL, postFileCors(formData, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else yield put(getBusinessGroupAction())
    return response
  } catch (err) {
    console.error("[route] --> /images/upload | POST logo client | ERROR |", err)
    yield put(setErrorMessage(err))
  }
}

function* deleteClientLogo({ payload }) {
  const { groupId } = payload
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { API_URL } = config
  const endPath = `deleteGroupLogo/${groupId}`
  const requestURL = `${API_URL}/${endPath}`

  try {
    const response = yield call(request, requestURL, deleteCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else yield put(getBusinessGroupAction())
  } catch (err) {
    console.error(`[route] --> ${endPath} | ERROR |`, err)
    yield put(setErrorMessage(err))
  }
}

function* addUserBusinessGroups({ payload }) {
  const token = yield select(selectCurrentToken)
  const business = yield select(selectBusiness)
  const specificHeaders = { token: token }
  const { API_URL } = config
  const requestURL = `${API_URL}/addUserFromMultiGroups`

  try {
    const response = yield call(request, requestURL, patchCors(payload, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(getBusinessGroupAction())
      yield put(getBusinessUsersAction({ businessId: business._id.$oid }))
    }
  } catch (err) {
    console.error("[route] => /addUserFromMultiGroups => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
// Delete User all Groups
function* deleteUserAllGroups({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { API_URL } = config
  const { userId } = payload
  const requestURL = `${API_URL}/removeUserFromAllGroups/${userId}`

  try {
    const response = yield call(request, requestURL, patchCors(payload, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(getBusinessGroupAction())
    }
  } catch (err) {
    console.error("[route] => /removeUserFromAllGroups/:userId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}
// Delete User all Groups and add users in group
function* onChangeUserInGroups({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { API_URL } = config
  const { userId, groupId } = payload
  const requestURL = `${API_URL}/removeUserFromAllGroups/${userId}`

  try {
    const response = yield call(request, requestURL, patchCors({}, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(addUserBusinessGroupAction({ groupId, userId }))
    }
  } catch (err) {
    console.error("[route] => /removeUserFromAllGroups/:userId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

// ***************************** //
//              Sagas            //
// ***************************** //
function* businessInformationsSaga() {
  yield takeEvery(BusinessTypes.CREATE_USER, createUserSaga)
  yield takeEvery(BusinessTypes.UPDATE_BUSINESS_USERS, updateUserSaga)
  yield takeEvery(BusinessTypes.GET_BUSINESS_USERS, getBusinessUsers)
  yield takeEvery(BusinessTypes.DELETE_USER, deleteUserSaga)
  yield takeEvery(BusinessTypes.UPDATE_BUSINESS_INFORMATIONS, updateBusinessInformations)
  yield takeEvery(BusinessTypes.GET_BUSINESS_INFORMATIONS, getMyBusinessInformationsSaga)

  yield takeEvery(BusinessTypes.GET_ROLES, getRolesSaga)
  yield takeEvery(BusinessTypes.CREATE_ROLE, createRoleSaga)
  yield takeEvery(BusinessTypes.UPDATE_ROLE, updateRoleSaga)
  yield takeEvery(BusinessTypes.DELETE_ROLE, deleteRoleSaga)

  yield takeEvery(BusinessTypes.CREATE_BUSINESS_ROLE_OLD_VERSION, createBusinessRole_OldVersion)
  yield takeEvery(BusinessTypes.UPDATE_BUSINESS_ROLE, updateBusinessRole)
  yield takeEvery(BusinessTypes.DELETE_BUSINESS_ROLE, deleteBusinessRole)

  yield takeEvery(BusinessTypes.GET_BUSINESS_LOGO, getBusinessLogo)
  yield takeEvery(BusinessTypes.UPLOAD_BUSINESS_LOGO, uploadBusinessLogo)
  yield takeEvery(BusinessTypes.UPDATE_CLIENT_LOGO, uploadClientLogo)
  yield takeEvery(BusinessTypes.DELETE_CLIENT_LOGO, deleteClientLogo)

  yield takeEvery(BusinessTypes.GET_ALREADY_USED_EMAIL, getCheckEmailAlreadyUsed)
  yield takeEvery(BusinessTypes.UPDATE_BUSINESS_DEFAULT_PALETTE, updateDefaultPalette)
  yield takeEvery(BusinessTypes.GET_BUSINESS_GROUP, getBusinessGroups)
  yield takeEvery(BusinessTypes.CREATE_GROUP, createGroupSaga)
  yield takeEvery(BusinessTypes.PATCH_GROUP, updateGroupById)
  yield takeEvery(BusinessTypes.DELETE_OR_ARCHIVE_GROUP, deleteOrArchiveGroupByIdSaga)
  yield takeEvery(BusinessTypes.ADD_USER_BUSINESS_GROUP, addUserBusinessGroups)
  yield takeEvery(BusinessTypes.GET_BUSINESS_GROUP_BY_ID, getBusinessGroupById)
  yield takeEvery(BusinessTypes.DELETE_USER_ALL_GROUP, deleteUserAllGroups)
  yield takeEvery(BusinessTypes.CHANGE_USER_IN_GROUP, onChangeUserInGroups)
  yield takeEvery(BusinessTypes.GET_MY_GROUPS, getMyBusinessGroups)
}

export default businessInformationsSaga
